import personalCard from './components/personalCard.vue';

export default {
  routes: [
    {
      path: '/:personal_id',
      component: personalCard,
      name: 'personalCard'
    },
    {
      path: '/',
      component: personalCard,
      name: 'newPersonalCard'
    },

  ]
};
